import CommitteeTitle from './CommitteeTitle';
import CommitteeStats from './CommitteeStats';
import CommitteeTabs from './CommitteeTabs';
import CommitteeTable from './CommitteeTable';
import sidebarShape from '../../assets/images/background-wavy.png';

const CommitteesPage = () => {
  return (
    <div className="relative bg-app-background min-h-full p-6 overflow-hidden">
      <img
        src={sidebarShape}
        alt=""
        className="absolute top-0 right-0 w-1500 pointer-events-none"
        style={{
          opacity: 0.1,
          filter: 'saturate(0.9)',
        }}
      />

      <div className="relative z-10">
        <CommitteeTitle />
        <CommitteeStats />
        <CommitteeTabs />
        <div className="mt-5">
          <CommitteeTable />
        </div>
      </div>
    </div>
  );
};

export default CommitteesPage;
